export var REQUIRED_ERROR = 'Requerido';
export var MIN_LENGTH_ERROR = function (current, min) { return "M\u00EDnimo ".concat(min, " caracteres. (Actual ").concat(current, ")"); };
export var MAX_LENGTH_ERROR = function (current, max) { return "M\u00E1ximo ".concat(max, " caracteres. (Actual ").concat(current, ")"); };
export var LENGTH_ERROR = function (current, len) { return "Requiere ".concat(len, " caracteres. (Actual ").concat(current, ")"); };
export var EMAIL_ERROR = 'Debe ser un email válido.';
export var CUIT_ERROR = 'Debe ser un CUIT válido.';
export var DNI_ERROR = 'Debe ser un DNI válido.';
